<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-setting"></i>
              后处理详情管理
            </h1>
            <p class="page-subtitle">管理订单项后处理详细信息和加工配置</p>
            <!-- 面包屑导航 -->
            <div class="breadcrumb-nav">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                  <router-link to="/customer/order">订单管理</router-link>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                  <router-link :to="`/customer/order/${$route.params.id}/customer_order_item`">订单项目</router-link>
                </el-breadcrumb-item>
                <el-breadcrumb-item>后处理详情</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
        </div>

        <!-- 订单信息卡片 -->
        <div class="order-info-card">
          <div class="info-header">
            <i class="el-icon-s-order"></i>
            <span>订单信息</span>
          </div>
          <div class="info-content">
            <div class="info-item">
              <span class="label">订单项ID：</span>
              <span class="value">{{$route.params.order_item_id}}</span>
            </div>
            <div class="info-item" v-if="routeFollowCraftId">
              <span class="label">筛选后处理工艺ID：</span>
              <span class="value">{{ routeFollowCraftId }}</span>
            </div>
            <div class="info-item" v-else>
              <span class="label">后处理范围：</span>
              <span class="value">本订单项下全部后处理明细</span>
            </div>
            <div class="info-item" v-if="orderItemSnapshot && (orderItemSnapshot.File || orderItemSnapshot.file)">
              <span class="label">订单项主文件：</span>
              <span class="value">{{ (orderItemSnapshot.File && orderItemSnapshot.File.file_name) || (orderItemSnapshot.file && orderItemSnapshot.file.file_name) || '—' }}</span>
            </div>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-header">
            <h3 class="action-title">
              <i class="el-icon-s-operation"></i>
              快速操作
            </h3>
          </div>
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加后处理详情" placement="top" v-if="userPermissions.indexOf('craft_add') != -1 && buttonType=='icon'">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()"></el-button>
            </el-tooltip>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="userPermissions.indexOf('craft_add') != -1 && buttonType=='text'" @click="addButton()">添加后处理详情</el-button>
            
            <el-tooltip effect="dark" content="批量导入" placement="top" v-if="buttonType=='icon'">
              <el-button type="warning" size="mini" icon="el-icon-upload2" @click="batchImport()"></el-button>
            </el-tooltip>
            <el-button type="warning" size="mini" icon="el-icon-upload2" v-if="buttonType=='text'" @click="batchImport()">批量导入</el-button>
            
            <el-tooltip effect="dark" content="导出数据" placement="top" v-if="buttonType=='icon'">
              <el-button type="success" size="mini" icon="el-icon-download" @click="exportData()"></el-button>
            </el-tooltip>
            <el-button type="success" size="mini" icon="el-icon-download" v-if="buttonType=='text'" @click="exportData()">导出数据</el-button>
            
            <el-tooltip effect="dark" content="返回上级" placement="top" v-if="buttonType=='icon'">
              <el-button type="info" size="mini" icon="el-icon-back" @click="goBack()"></el-button>
            </el-tooltip>
            <el-button type="info" size="mini" icon="el-icon-back" v-if="buttonType=='text'" @click="goBack()">返回上级</el-button>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span class="search-title">筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item label="后处理名称">
                <el-input v-model="searchCondition.craft_name" placeholder="请输入后处理名称" clearable prefix-icon="el-icon-cpu">
                </el-input>
              </el-form-item>
              <el-form-item label="加工信息">
                <el-input v-model="searchCondition.info" placeholder="请输入加工信息" clearable prefix-icon="el-icon-document">
                </el-input>
              </el-form-item>
              <el-form-item label="工期范围">
                <el-input-number v-model="searchCondition.min_days" :min="0" placeholder="最小天数" size="mini"></el-input-number>
                <span style="margin: 0 8px;">-</span>
                <el-input-number v-model="searchCondition.max_days" :min="0" placeholder="最大天数" size="mini"></el-input-number>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
                <el-button size="mini" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <div class="table-header">
            <div class="header-left">
              <h3 class="table-title">
                <i class="el-icon-menu"></i>
                后处理详情列表
              </h3>
            </div>
            <div class="header-right">
              <span class="data-count">共 {{pagingData.total}} 条数据</span>
            </div>
          </div>
          
          <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" label="序号" align="center">
              <template slot-scope="scope">
                <span class="sequence-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>
            
            <el-table-column label="后处理基础信息" min-width="200">
              <template slot-scope="scope">
                <div class="craft-info">
                  <div class="info-item">
                    <i class="el-icon-cpu"></i>
                    <span class="info-label">后处理名称：</span>
                    <span class="info-value craft-name">{{displayFollowCraftName(scope.row)}}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-star-on"></i>
                    <span class="info-label">类型：</span>
                    <el-tag size="mini" type="primary">{{displayFollowCraftType(scope.row)}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="后处理内容说明" min-width="240">
              <template slot-scope="scope">
                <div class="process-info">
                  <div class="info-item craft-params-block">
                    <i class="el-icon-document-copy"></i>
                    <span class="info-label">参数：</span>
                    <div v-if="!craftParamLines(scope.row.info).length" class="muted">—</div>
                    <div v-else class="param-list">
                      <div v-for="(line, pix) in craftParamLines(scope.row.info)" :key="'p'+pix" class="param-line">
                        <span class="param-k">{{ line.label }}</span>
                        <span class="param-sep">：</span>
                        <span class="param-v">{{ line.value }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="info-item" v-if="followCraftDesc(scope.row)">
                    <i class="el-icon-info"></i>
                    <span class="info-label">工艺说明：</span>
                    <span class="info-value desc-text">{{ followCraftDesc(scope.row) }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-time"></i>
                    <span class="info-label">创建时间：</span>
                    <span class="info-value time">{{formatDate(scope.row.created_at)}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="附件文件" min-width="228">
              <template slot-scope="scope">
                <div class="attach-cell">
                  <template v-if="getCraftAttachmentFiles(scope.row).length">
                    <div v-for="(f, fi) in getCraftAttachmentFiles(scope.row)" :key="'f'+fi" class="attach-row">
                      <template v-if="isImageAttachment(f) && attachmentDownloadUrl(f)">
                        <el-image
                          class="attach-thumb"
                          :src="attachmentDownloadUrl(f)"
                          fit="cover"
                          :preview-src-list="craftAttachmentImagePreviewUrls(scope.row)"
                        >
                          <div slot="error" class="attach-thumb-error">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <div class="attach-thumb-meta">
                          <span class="attach-thumb-name">{{ fileDisplayName(f) }}</span>
                          <el-button type="text" size="mini" icon="el-icon-download" @click.stop="openAttachmentDownload(f)">下载</el-button>
                        </div>
                      </template>
                      <template v-else>
                        <el-button
                          type="text"
                          size="mini"
                          icon="el-icon-download"
                          class="attach-download-btn"
                          :disabled="!attachmentDownloadUrl(f)"
                          @click="openAttachmentDownload(f)"
                        >{{ fileDisplayName(f) }}</el-button>
                      </template>
                    </div>
                  </template>
                  <span v-else class="muted">无单独附件</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="后处理工期" min-width="120" align="center">
              <template slot-scope="scope">
                <div class="duration-info">
                  <el-tag type="info" size="medium">
                    <i class="el-icon-timer"></i>
                    {{scope.row.duration}}天
                  </el-tag>
                  <div class="duration-bar">
                    <el-progress :percentage="getDurationPercentage(scope.row.duration)" :stroke-width="6" :show-text="false"></el-progress>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="数量" min-width="100" align="center">
              <template slot-scope="scope">
                <div class="quantity-info">
                  <el-tag type="primary" size="large">
                    <i class="el-icon-goods"></i>
                    {{scope.row.quantity}}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="后处理价格" min-width="140" align="center">
              <template slot-scope="scope">
                <div class="price-info">
                  <div class="price-item">
                    <span class="price-label">后处理单价：</span>
                    <el-tag type="warning" size="mini">¥{{formatMoney(scope.row.follow_craft_price)}}</el-tag>
                  </div>
                  <div class="price-item">
                    <span class="price-label">后处理总价：</span>
                    <el-tag type="danger" size="mini">¥{{formatMoney(scope.row.total_price)}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="更新时间" min-width="160" align="center">
              <template slot-scope="scope">
                <span class="info-value time">{{formatDate(scope.row.updated_at)}}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="buttonType=='icon'" width="220" label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑" placement="top" v-if="userPermissions.indexOf('craft_modify') != -1">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="复制" placement="top" v-if="userPermissions.indexOf('craft_add') != -1">
                    <el-button size="mini" icon="el-icon-copy-document" circle type="warning" @click="copyButton(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="详情" placement="top">
                    <el-button size="mini" icon="el-icon-view" circle type="info" @click="viewDetail(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除" placement="top">
                    <span>
                      <el-popover
                        v-if="userPermissions.indexOf('craft_delete') != -1"
                        placement="top"
                        width="180"
                        v-model="scope.row.visible">
                        <p>确定要删除这条后处理详情吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                          <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                        </div>
                        <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                      </el-popover>
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 添加/编辑抽屉 -->
    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="120px">
          <el-row v-if="showFollowCraftSelect">
            <el-col :span="22">
              <el-form-item label="后处理工艺" prop="follow_craft_id">
                <el-select v-model="formData.follow_craft_id" filterable placeholder="请选择后处理工艺" style="width:100%" @change="onFollowCraftOptionChange">
                  <el-option
                    v-for="opt in followCraftOptions"
                    :key="opt.id"
                    :label="opt.follow_craft_name"
                    :value="opt.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="22">
              <el-form-item label="后处理工艺" prop="follow_craft_name">
                <el-input v-model="formData.follow_craft_name" prefix-icon="el-icon-cpu" placeholder="请输入后处理工艺名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="加工信息" prop="info">
                <el-input type="textarea" v-model="formData.info" :rows="4" placeholder="请输入详细的加工信息和要求"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="工期(天)" prop="elapsed_days">
                <el-input-number v-model="formData.elapsed_days" :min="1" :max="365" prefix-icon="el-icon-time"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="数量" prop="quantity">
                <el-input-number v-model="formData.quantity" :min="1" :max="99999" prefix-icon="el-icon-goods"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="单价(元)" prop="price">
                <el-input-number v-model="formData.price" :precision="2" :min="0" prefix-icon="el-icon-money"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="状态" prop="status">
                <el-select v-model="formData.status" placeholder="请选择状态">
                  <el-option label="待处理" value="0"></el-option>
                  <el-option label="处理中" value="1"></el-option>
                  <el-option label="已完成" value="2"></el-option>
                  <el-option label="已暂停" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="formData.remark" :rows="3" placeholder="请输入备注信息（可选）"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>

    <el-dialog title="后处理明细详情" :visible.sync="detailDialogVisible" width="640px" append-to-body @closed="detailDialogRow = null">
      <div v-if="detailDialogRow" class="detail-dialog-body">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="后处理名称">{{ displayFollowCraftName(detailDialogRow) }}</el-descriptions-item>
          <el-descriptions-item label="工艺类型">{{ displayFollowCraftType(detailDialogRow) }}</el-descriptions-item>
          <el-descriptions-item label="数量">{{ detailDialogRow.quantity }}</el-descriptions-item>
          <el-descriptions-item label="工期(天)">{{ detailDialogRow.duration }}</el-descriptions-item>
          <el-descriptions-item label="单价">¥{{ formatMoney(detailDialogRow.follow_craft_price) }}</el-descriptions-item>
          <el-descriptions-item label="总价">¥{{ formatMoney(detailDialogRow.total_price) }}</el-descriptions-item>
          <el-descriptions-item label="明细记录ID">{{ detailDialogRow.id }}</el-descriptions-item>
          <el-descriptions-item label="后处理工艺ID">{{ detailDialogRow.follow_craft_id }}</el-descriptions-item>
          <el-descriptions-item label="工艺说明">{{ followCraftDesc(detailDialogRow) || '—' }}</el-descriptions-item>
          <el-descriptions-item label="附件文件">
            <template v-if="getCraftAttachmentFiles(detailDialogRow).length">
              <div v-for="(f, i) in getCraftAttachmentFiles(detailDialogRow)" :key="i" class="detail-attach-block">
                <template v-if="isImageAttachment(f) && attachmentDownloadUrl(f)">
                  <el-image
                    class="attach-thumb detail-attach-thumb"
                    :src="attachmentDownloadUrl(f)"
                    fit="cover"
                    :preview-src-list="craftAttachmentImagePreviewUrls(detailDialogRow)"
                  >
                    <div slot="error" class="attach-thumb-error">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div class="attach-thumb-meta">
                    <span class="attach-thumb-name">{{ fileDisplayName(f) }}</span>
                    <el-button type="text" size="small" icon="el-icon-download" @click.stop="openAttachmentDownload(f)">下载</el-button>
                  </div>
                </template>
                <template v-else>
                  <el-button type="text" size="small" icon="el-icon-download" :disabled="!attachmentDownloadUrl(f)" @click="openAttachmentDownload(f)">{{ fileDisplayName(f) }}</el-button>
                </template>
              </div>
            </template>
            <span v-else>—</span>
          </el-descriptions-item>
        </el-descriptions>
        <div class="detail-json-title">参数原始结构（JSON）</div>
        <pre class="detail-json-pre">{{ craftInfoJsonPretty(detailDialogRow.info) }}</pre>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import { getFollowCraftTypeLabel } from '@/utils/followCraftTypeMap'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchGeneralCondition:{
        current_page: 1,
        page_size: 10,
        query: "",
        params: [],
      },
      searchCondition:{
        craft_name: '',
        info: '',
        min_days: '',
        max_days: ''
      },
      searchRolesCondition: {
        current_page: 1,
        page_size: 200,
        query: "",
        params: [],
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        follow_craft_name: [{required: true,message:'请输入后处理工艺名称', trigger: 'blur' }],
        info: [{required: true,message:'请输入加工信息', trigger: 'blur' }],
        elapsed_days: [{required: true,message:'请选择工期', trigger: 'blur' }],
        quantity: [{required: true,message:'请输入数量', trigger: 'blur' }],
        price: [{required: true,message:'请输入价格', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '工艺详情',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: [],
      orderItemSnapshot: null,
      followCraftOptions: [],
      detailDialogVisible: false,
      detailDialogRow: null,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    routeFollowCraftId() {
      const id = this.$route.params.follow_craft_id
      if (id == null || id === '' || String(id).trim() === '') return ''
      return String(id).trim()
    },
    showFollowCraftSelect() {
      const id = this.formData && this.formData.id
      const isNew = !id || id === 0 || id === '0'
      return isNew && !this.routeFollowCraftId
    },
  },
  methods: {
    // 组装分页 + 筛选 query/params（列名与 ola_app_customer_order_item_craft_detail 一致；工艺名在 JSON 字段 info 中检索）
    setSearchCondition() {
      this.searchGeneralCondition.query = ''
      this.searchGeneralCondition.params = []
      if (this.$refs['apeTable']) {
        Object.assign(this.searchGeneralCondition, this.$refs['apeTable'].getPagingInfo())
      }
      const parts = []
      const params = []
      if (this.searchCondition.craft_name !== '' && this.searchCondition.craft_name != null) {
        parts.push('instr(info,?)')
        params.push(this.searchCondition.craft_name)
      }
      if (this.searchCondition.info !== '' && this.searchCondition.info != null) {
        parts.push('instr(info,?)')
        params.push(this.searchCondition.info)
      }
      if (this.searchCondition.min_days !== '' && this.searchCondition.min_days != null) {
        parts.push('duration >= ?')
        params.push(this.searchCondition.min_days)
      }
      if (this.searchCondition.max_days !== '' && this.searchCondition.max_days != null) {
        parts.push('duration <= ?')
        params.push(this.searchCondition.max_days)
      }
      if (parts.length) {
        this.searchGeneralCondition.query = parts.join(' and ')
        this.searchGeneralCondition.params = params
      }
    },
    // 搜索
    searchButton() {
      this.searchGeneralCondition.current_page = 1
      if (this.$refs['apeTable']) {
        this.$refs['apeTable'].currentPage = 1
      }
      this.getList()
    },
    // 重置搜索条件
    resetSearch() {
      this.searchCondition.craft_name = ''
      this.searchCondition.info = ''
      this.searchCondition.min_days = ''
      this.searchCondition.max_days = ''
      this.getList()
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    // 响应添加按钮
    async addButton() {
      this.formData = { id: 0, follow_craft_id: this.routeFollowCraftId || '' }
      if (this.showFollowCraftSelect && !this.followCraftOptions.length) {
        await this.loadFollowCraftOptions()
      }
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    onFollowCraftOptionChange(val) {
      const o = (this.followCraftOptions || []).find((x) => x.id === val)
      if (o) this.formData.follow_craft_name = o.follow_craft_name
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑工艺详情(ID：'+id+')'
      let res = await this.$api.post('/service/customer_order/craft_detail_detail', {id: id})
      if (this.$apiSuccess(res)) {
        const d = res.data.detail
        const fc = (d && d.FollowCraft) || {}
        this.formData = Object.assign({}, d, {
          follow_craft_name: fc.follow_craft_name || '',
          price: d.follow_craft_price,
          elapsed_days: d.duration,
          follow_craft_id: d.follow_craft_id || (fc && fc.id) || '',
        })
        if (d && d.info != null && typeof d.info === 'object') {
          this.formData.info = JSON.stringify(d.info, null, 2)
        }
      } else {
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      if (this.showFollowCraftSelect && (!this.formData.follow_craft_id || String(this.formData.follow_craft_id).trim() === '')) {
        this.$message.error('请选择后处理工艺')
        return
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    parseCraftInfoPayload() {
      const raw = this.formData.info
      if (raw == null || raw === '') return []
      if (typeof raw !== 'string') return raw
      try {
        return JSON.parse(raw)
      } catch (e) {
        return null
      }
    },
    buildCraftDetailSubmitBody() {
      const infoVal = this.parseCraftInfoPayload()
      if (infoVal === null) {
        return null
      }
      const base = {
        quantity: this.formData.quantity,
        follow_craft_price: Number(this.formData.price),
        duration: Number(this.formData.elapsed_days),
        info: infoVal,
      }
      const fcId = (this.formData.follow_craft_id && String(this.formData.follow_craft_id).trim()) || this.routeFollowCraftId
      if (!fcId) {
        this.$message.error('请选择或指定后处理工艺')
        return null
      }
      if (this.formData.id != null && this.formData.id !== 0 && this.formData.id !== '0') {
        return Object.assign({ id: this.formData.id }, base)
      }
      return Object.assign(
        {
          order_item_id: this.$route.params.order_item_id,
          follow_craft_id: fcId,
        },
        base
      )
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      const body = this.buildCraftDetailSubmitBody()
      if (!body) {
        this.$message.error('加工信息须为合法 JSON')
        this.drawerData.loading = false
        return
      }
      let res
      if (this.formData.id == null || this.formData.id === 0 || this.formData.id === '0') {
        res = await this.$api.post('/service/customer_order/craft_detail_create', body)
      } else {
        res = await this.$api.post('/service/customer_order/craft_detail_update', body)
      }
      
      if (this.$apiSuccess(res)) {
        this.$nextTick(() => {
          this.drawerData.visible = false
        })
        this.$nextTick(async () => {
          this.getList()
        })
        this.$nextTick(() => {
          this.$message.success('保存成功!')
        })
      } else {
        this.$message.error(res.message)
      }
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/customer_order/craft_detail_delete', {id: id})
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(res.message)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async getList() {
      this.loadingStaus=true
      this.setSearchCondition()
      const payload = Object.assign({}, this.searchGeneralCondition, {
        order_item_id: this.$route.params.order_item_id,
      })
      if (this.routeFollowCraftId) {
        payload.follow_craft_id = this.routeFollowCraftId
      }
      let res = await this.$api.post('/service/customer_order/craft_detail_list', payload)
      if (this.$apiSuccess(res)){
        this.dataList = res.data.list || []
        const pg = res.data.page
        this.pagingData.total = pg && pg.total != null ? pg.total : 0
        this.offset = (this.searchGeneralCondition.current_page - 1) * this.searchGeneralCondition.page_size
      }else{
        this.$message.error(res.message)
        this.dataList=[]
        this.loadingStaus=false
        return
      }
      this.loadingStaus=false
    },
    displayFollowCraftName(row) {
      const fc = row.FollowCraft || row.followCraft
      return fc && fc.follow_craft_name ? fc.follow_craft_name : '—'
    },
    displayFollowCraftType(row) {
      const fc = row.FollowCraft || row.followCraft
      const t = fc && fc.follow_craft_type
      if (t == null || String(t).trim() === '') return '—'
      const label = getFollowCraftTypeLabel(t)
      return label || String(t).trim()
    },
    craftParamLines(info) {
      if (info == null || info === '') return []
      let obj = info
      if (typeof info === 'string') {
        try {
          obj = JSON.parse(info)
        } catch (e) {
          return [{ label: '内容', value: info.length > 500 ? info.slice(0, 500) + '…' : info }]
        }
      }
      if (Array.isArray(obj)) {
        return obj.map((item, i) => {
          if (item && typeof item === 'object') {
            const k = item.key != null ? item.key : item.Key
            const v = item.value != null ? item.value : item.Value
            if (k !== undefined || v !== undefined) {
              return { label: String(k != null ? k : '项' + (i + 1)), value: String(v != null ? v : '') }
            }
          }
          try {
            return { label: '项' + (i + 1), value: JSON.stringify(item) }
          } catch (e2) {
            return { label: '项' + (i + 1), value: String(item) }
          }
        })
      }
      if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).map((k) => ({ label: k, value: String(obj[k]) }))
      }
      return [{ label: '内容', value: String(obj) }]
    },
    followCraftDesc(row) {
      const fc = row.FollowCraft || row.followCraft
      const d = fc && fc.follow_craft_desc
      return d != null && String(d).trim() !== '' ? String(d).trim() : ''
    },
    parseIdArray(raw) {
      if (raw == null) return []
      if (Array.isArray(raw)) return raw
      if (typeof raw === 'string') {
        try {
          const j = JSON.parse(raw)
          return Array.isArray(j) ? j : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    getCraftAttachmentFiles(row) {
      if (!this.orderItemSnapshot || !row) return []
      const all = this.orderItemSnapshot.resolved_attachment_files || []
      if (!all.length) return []
      const ids = new Set(this.parseIdArray(row.attachment_file_ids).map((id) => String(id || '').trim()).filter(Boolean))
      if (!ids.size) return []
      return all.filter((f) => ids.has(String(f.id || '').trim()))
    },
    fileDisplayName(f) {
      if (!f) return ''
      return f.file_name || f.FileName || f.id || ''
    },
    publicAssetUrl(path) {
      if (path == null || path === '') return ''
      const s = String(path).replace(/\\/g, '/')
      if (/^https?:\/\//i.test(s)) return s
      if (s.startsWith('/assets/')) return s
      const marker = '/assetslib/'
      const i = s.indexOf(marker)
      if (i !== -1) {
        return '/assets/' + s.slice(i + marker.length).replace(/^\/+/, '')
      }
      return s
    },
    attachmentDownloadUrl(f) {
      if (!f) return ''
      const p = f.file_path != null && f.file_path !== '' ? f.file_path : f.FilePath
      return this.publicAssetUrl(p)
    },
    isImageAttachment(f) {
      if (!f) return false
      const imageFormats = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'])
      const fmt = String(f.file_format != null ? f.file_format : f.FileFormat || '')
        .toLowerCase()
        .replace(/^\./, '')
      if (fmt && imageFormats.has(fmt)) return true
      const name = String(this.fileDisplayName(f) || '')
      const dot = name.lastIndexOf('.')
      if (dot !== -1) {
        const ext = name.slice(dot + 1).toLowerCase()
        if (imageFormats.has(ext)) return true
      }
      const u = this.attachmentDownloadUrl(f)
      if (u) {
        try {
          const pathOnly = u.split('?')[0]
          const last = pathOnly.lastIndexOf('.')
          if (last !== -1) {
            const ext = pathOnly.slice(last + 1).toLowerCase()
            if (imageFormats.has(ext)) return true
          }
        } catch (e) { /* noop */ }
      }
      return false
    },
    craftAttachmentImagePreviewUrls(row) {
      return this.getCraftAttachmentFiles(row)
        .filter((f) => this.isImageAttachment(f))
        .map((f) => this.attachmentDownloadUrl(f))
        .filter(Boolean)
    },
    openAttachmentDownload(f) {
      const u = this.attachmentDownloadUrl(f)
      if (u) window.open(u, '_blank')
      else this.$message.warning('暂无可用下载地址')
    },
    craftInfoJsonPretty(info) {
      if (info == null || info === '') return '—'
      try {
        const v = typeof info === 'string' ? JSON.parse(info) : info
        return JSON.stringify(v, null, 2)
      } catch (e) {
        return String(info)
      }
    },
    formatMoney(v) {
      if (v == null || v === '') return '0.00'
      const n = Number(v)
      return Number.isFinite(n) ? n.toFixed(2) : '0.00'
    },
    // 获取工期百分比
    getDurationPercentage(elapsedDays) {
      if (elapsedDays === 0) {
        return 0;
      }
      return Math.min(100, (elapsedDays / 365) * 100);
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 批量导入
    batchImport() {
      this.$message.info('批量导入功能开发中...')
    },
    // 导出数据
    exportData() {
      this.$message.info('数据导出功能开发中...')
    },
    // 返回上级
    goBack() {
      this.$router.go(-1)
    },
    // 复制工艺详情
    copyButton(row) {
      const fc = row.FollowCraft || {}
      let infoStr = ''
      if (row.info != null) {
        infoStr = typeof row.info === 'string' ? row.info : JSON.stringify(row.info, null, 2)
      }
      this.formData = {
        follow_craft_name: fc.follow_craft_name || '',
        info: infoStr,
        elapsed_days: row.duration,
        price: row.follow_craft_price,
        quantity: row.quantity,
        follow_craft_id: row.follow_craft_id || (fc && fc.id) || this.routeFollowCraftId || '',
      }
      this.formData.id = undefined
      this.drawerData.visible = true
      this.drawerData.title = '复制工艺详情'
      this.drawerData.loading = false
      this.$message.success('已复制工艺详情，请修改后保存！')
    },
    viewDetail(row) {
      this.detailDialogRow = row
      this.detailDialogVisible = true
    },
    async loadOrderItemContext() {
      const oid = this.$route.params.order_item_id
      if (!oid) return
      const res = await this.$api.post('/service/customer_order/order_item_detail', { id: oid })
      if (this.$apiSuccess(res) && res.data.detail) {
        this.orderItemSnapshot = res.data.detail
      }
    },
    async loadFollowCraftOptions() {
      const res = await this.$api.post('/service/ola_app_follow_craft/list', {
        current_page: 1,
        page_size: 500,
        query: '',
        params: [],
      })
      if (this.$apiSuccess(res) && res.data.list) {
        this.followCraftOptions = res.data.list
      }
    },
  },
  mounted() {
    this.loadOrderItemContext().then(() => {
      if (!this.routeFollowCraftId) {
        return this.loadFollowCraftOptions()
      }
    }).finally(() => {
      this.getList()
    })
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0 0 12px 0
      opacity 0.9
      font-size 14px
    
    .breadcrumb-nav
      margin-top 12px
      
      /deep/ .el-breadcrumb
        .el-breadcrumb__item
          .el-breadcrumb__inner
            color rgba(255, 255, 255, 0.8)
            font-weight 500
            
            &:hover
              color white
              text-decoration underline
          
          &:last-child
            .el-breadcrumb__inner
              color white
              font-weight 600

// 订单信息卡片样式
.order-info-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  border-left 4px solid #409eff
  
  .info-header
    display flex
    align-items center
    margin-bottom 16px
    font-size 16px
    font-weight 600
    color #303133
    
    i
      color #409eff
      margin-right 8px
      font-size 18px
  
  .info-content
    display flex
    flex-wrap wrap
    gap 20px
    
    .info-item
      display flex
      align-items center
      
      .label
        color #909399
        margin-right 8px
        font-weight 500
      
      .value
        color #303133
        font-weight 600
        font-family 'Monaco', 'Consolas', monospace
        background #f5f7fa
        padding 4px 8px
        border-radius 4px
        border 1px solid #e4e7ed

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-header
    margin-bottom 16px
    
    .action-title
      display flex
      align-items center
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      
      i
        margin-right 8px
        color #409eff
        font-size 18px
  
  .action-buttons
    display flex
    gap 8px
    flex-wrap wrap

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    
    i
      margin-right 8px
      color #409eff
      font-size 16px
    
    .search-title
      font-weight 600
      color #303133
      font-size 15px
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px
        
        &:last-child
          margin-right 0

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5
    
    .header-left
      .table-title
        color #1f2937
        font-size 18px
        font-weight 600
        margin 0
        display flex
        align-items center
        gap 8px
        
        i
          color #409eff
          
    .header-right
      .data-count
        color #6b7280
        font-size 14px
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

.muted
  color #909399
  font-size 12px

.param-list
  flex 1
  min-width 0

.param-line
  font-size 12px
  line-height 1.5
  margin-bottom 2px
  .param-k
    color #606266
    font-weight 500
  .param-sep
    margin 0 2px
  .param-v
    color #303133
    word-break break-all

.craft-params-block
  align-items flex-start !important

.attach-cell
  font-size 12px
  line-height 1.45
  .attach-row
    margin-bottom 12px
    &:last-child
      margin-bottom 0
  .attach-thumb
    width 200px
    height 200px
    display block
    border-radius 8px
    overflow hidden
    border 1px solid #ebeef5
    cursor zoom-in
    >>> .el-image__inner
      width 100% !important
      height 100% !important
  .detail-attach-thumb
    margin-bottom 0
  .attach-thumb-error
    display flex
    align-items center
    justify-content center
    width 100%
    height 100%
    background #f5f7fa
    color #c0c4cc
    font-size 28px
  .attach-thumb-meta
    display flex
    align-items center
    justify-content space-between
    gap 8px
    margin-top 6px
    max-width 200px
  .attach-thumb-name
    font-size 12px
    color #606266
    flex 1
    min-width 0
    word-break break-all
    line-height 1.35
  .attach-download-btn
    word-break break-all
    text-align left
    padding 0
    max-width 100%
    white-space normal
    height auto
    line-height 1.4

.detail-attach-block
  margin-bottom 12px
  &:last-child
    margin-bottom 0

.detail-json-title
  margin 12px 0 8px
  font-size 13px
  font-weight 600
  color #303133

.detail-json-pre
  margin 0
  padding 12px
  background #f5f7fa
  border-radius 8px
  font-size 11px
  line-height 1.4
  max-height 240px
  overflow auto
  border 1px solid #ebeef5

.desc-text
  word-break break-word
  line-height 1.4

// 信息显示样式
.craft-info, .process-info
  .info-item
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 16px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 60px
    
    .info-value
      color #303133
      font-weight 500
      
      &.craft-name
        color #409eff
        font-weight 600
      
      &.time
        color #67c23a
        font-size 11px

// 工期信息样式
.duration-info
  display flex
  flex-direction column
  align-items center
  gap 8px
  
  .duration-bar
    width 60px
    
    /deep/ .el-progress-bar__outer
      background #f0f2f5

// 价格信息样式
.price-info
  display flex
  flex-direction column
  gap 4px
  
  .price-item
    display flex
    align-items center
    justify-content center
    font-size 11px
    
    .price-label
      margin-right 4px
      color #909399
      font-weight 500

// 状态信息样式
.status-info
  display flex
  justify-content center
  
  .el-tag
    i
      margin-right 4px

// 数量显示样式
.quantity-info
  display flex
  justify-content center
  
  .el-tag
    border-radius 8px
    font-weight 600
    
    i
      margin-right 4px

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  flex-wrap wrap
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .order-info-card
    .info-content
      flex-direction column
      gap 10px
  
  .action-card
    .action-buttons
      justify-content center
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px
  
  .table-header
    flex-direction column
    align-items flex-start
    gap 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-tag
  border-radius 6px
  
  &.el-tag--large
    padding 8px 12px
    font-size 13px
  
  &.el-tag--medium
    padding 6px 10px
    font-size 12px
  
  &.el-tag--mini
    padding 2px 6px
    font-size 11px

// 表单优化
/deep/ .el-form
  .el-form-item__label
    color #374151
    font-weight 500
    
  .el-input__inner, .el-textarea__inner
    border 1px solid #d1d5db
    
    &:focus
      border-color #409eff
      box-shadow 0 0 0 2px rgba(64, 158, 255, 0.1)

// 面包屑优化
/deep/ .el-breadcrumb
  .el-breadcrumb__separator
    color rgba(255, 255, 255, 0.6)

// 表格优化
/deep/ .el-table
  .el-button.is-circle
    margin 0 2px
</style>
